import { axiosInstance } from 'src/utils/axiosInstance.utils';
import { apiUrls } from 'src/utils/properties.utils';

export const login = async (values: any) => {
  return await axiosInstance.post(apiUrls.LOGIN, values);
};

export const forgotPassword = async (email: string) => {
  return await axiosInstance.post(apiUrls.FORGOT_PASSWORD, { email });
};

export const resetPasswordWithToken = async (
  token: string,
  newPassword: string
) => {
  return await axiosInstance.post(apiUrls.RESET_PASSWORD_WITH_TOKEN, {
    token,
    newPassword,
  });
};

export const checkEmailExists = async (
  email: string
): Promise<string | null> => {
  const response = await axiosInstance.post(apiUrls.CHECK_EMAIL_EXISTENCE, {
    email,
  });
  return response.data.message || null;
};

export const checkRegNoExists = async (
  regNo: string
): Promise<string | null> => {
  const response = await axiosInstance.get(apiUrls.CHECK_REG_NO, {
    params: { regNo },
  });
  return response.data.message || null;
};

export const registerCompanyAndUser = async (
  formData: FormData
): Promise<{ message: string }> => {
  try {
    const response = await axiosInstance.post(apiUrls.SIGNUP, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
